export default __webpack_public_path__ + "static/media/berlinsignet_dark.df2bebfd.png";